// bem-module-loader
// wrap css module in func that generates className
var content = require("!!../../../../node_modules/style-loader/index.js!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./ReviewForm.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
var b_ = require('/var/www/yii/prod.smartprogress/node_modules/bem-classname/dist/index.js');
var realContent = (typeof content.locals === 'object') ? content.locals : content
function bemModule() {
return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
}
bemModule.content = content;
module.exports = bemModule;


//////////////////
// WEBPACK FOOTER
// ./src/react/elements/ReviewList/ReviewForm.scss
// module id = 954
// module chunks = 20